import type { FC, ReactElement } from 'react';
import * as Chakra from '@chakra-ui/react';
import { QFlex } from '../../../QLayouts';
import { QEmptyState } from '../../../QComponents';
import { useLibraryTranslation } from '../../../i18n';

export type QEmptyInitiallyTableProps = {
  colSpan: number;
  children: ReactElement[];
};

export const QEmptyInitiallyTable: FC<QEmptyInitiallyTableProps> = ({
  colSpan,
  children,
}) => {
  const { t } = useLibraryTranslation();
  return (
    <Chakra.Tr>
      <Chakra.Td colSpan={colSpan}>
        <QFlex justifyContent="center">
          {children.length === 0 ? (
            <QEmptyState
              title={t('table.emptyInitial')}
              data-cy="data-table-empty"
            />
          ) : (
            children
          )}
        </QFlex>
      </Chakra.Td>
    </Chakra.Tr>
  );
};
